/**
 * Encodes a JS object of tracking meta into a string.
 * Note: Fanatics has a 255-character limit
 * @param {object} meta
 * @returns {string}
 */
export function encodeAffiliateMeta(meta) {
  let encodedObject;

  try {
    const jsonString = JSON.stringify(meta);
    const percentEncodedUnicode = encodeURIComponent(jsonString);
    const rawBytes = percentEncodedUnicode.replace(/%([0-9A-F]{2})/g, (match, p1) => String.fromCharCode(`0x${p1}`));
    encodedObject = btoa(rawBytes);

    if (encodedObject?.length >= 255) {
      if ('timestamp' in meta && ((encodedObject.length - 28) <= 255)) {
        delete meta.timestamp; // eslint-disable-line no-param-reassign
        encodedObject = encodeAffiliateMeta(meta);
      }
    }

  } catch (err) {
    console.error('encodeAffiliateMeta:', err, 'meta:', JSON.stringify(meta));
  }

  return encodedObject;
}

/**
 * Decodes a string of tracking meta back into a JS object
 * @param {string} encodedMeta
 * @returns {*}
 */
export function decodedAffiliateMeta(encodedMeta) {
  let decodedObject;

  try {
    const rawBytes = atob(encodedMeta);
    const percentEncodedUnicode = rawBytes.split('').map((c) => `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`).join('');
    const jsonString = decodeURIComponent(percentEncodedUnicode);
    decodedObject = JSON.parse(jsonString);
  } catch (err) {
    console.error('decodeAffiliateMeta:', err, 'encodedMeta:', encodedMeta);
  }

  return decodedObject;
}
